import Link from 'next/link';
import React from 'react';
import KnowledgeHubAccordion from './KnowledgeHubAccordion';
import KnowledgeHubTitle from './KnowledgeHubTitle';

function KnowledgeHubFAQs({ title, description, data }) {
  return (
    <>
      <div className="main">
        <div className="side_content">
          <KnowledgeHubTitle text={title} isStickySize />
          {description && <p className="description ">{description}</p>}
          {description && (
            <Link legacyBehavior href={'/faq-hub'}>
              <span className="faq_link">
                Explore all FAQs{' '}
                <img draggable="false"
                  src={'/icons/icon-arrow-right-red-large.svg'}
                  alt="arrow-right-red"
                />
              </span>
            </Link>
          )}
        </div>
        <div className="list">
          {data?.map((item, idx) => (
            <KnowledgeHubAccordion
              key={idx}
              title={item.question}
              content={item.answer_with_formatting}
            />
          ))}
        </div>
      </div>
      <style jsx>{`
        .faq_link {
          font-family: 'Roboto-Medium';
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: left;
          color: #fd0300;
          gap: 8px;
          cursor: pointer;
          display: flex;
          align-items: center;
          margin-top: 12px;
        }
        .description {
          font-family: 'Roboto-Medium';
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: left;
          padding: 0;
          margin: 0;
          margin-top: 12px;
        }
        .main {
          display: grid;
          gap: 32px;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          margin-top: 40px;
          padding-bottom: 76px;
        }
        .side_content {
          grid-column: span 1 / span 1;
        }
        .list {
          grid-column: span 3 / span 3;
        }
        @media (max-width: 991px) {
          .main {
            grid-template-columns: repeat(1, minmax(0, 1fr));
            margin-top: 24px;
            padding-bottom: 36px;
            gap: 12px;
          }
          .side_content {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
}

export default KnowledgeHubFAQs;
